module.exports = __webpack_public_path__ + "static/media/transport_markus-spiske-8eDOHGxQtuI-unsplash.71f75106.jpg";